/**
 * @file    tableLayout
 * @scope   SHARED
 * @summary Pure class-name helpers for the table containers.
 * @produces hasSubtitle, joinClasses
 * @sideEffects None.
 */
import { getOneQuestionSubTitle } from 'helpers/utilities';

export const hasSubtitle = (rawData: any, customWidgetConfig: any) =>
  !!rawData?.subTitle || getOneQuestionSubTitle(customWidgetConfig) !== null;

export const joinClasses = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');
